"use client";
/**
 * NuȘtiiUndeÎi wordmark logo.
 *
 * Pure SVG/text — no external image dependency.
 * The brand name uses mixed-case diacritics: NuȘtiiUndeÎi
 *
 * The logotype is rendered as two styled text spans to replicate the
 * visual brand split:
 *   "Nu" — white/light
 *   "Știi" — orange
 *   "Unde" — white/light
 *   "Îi" — orange
 *
 * A small orange square icon precedes the wordmark.
 */

interface NustiiLogoProps {
  /** "sm" = compact (above form on mobile), "lg" = full panel size */
  size?: "sm" | "lg";
  /** Dark background variant (default) or light card variant */
  variant?: "dark" | "light";
}

export function NustiiLogo({
  size = "sm",
  variant = "dark",
}: NustiiLogoProps) {
  const isLg = size === "lg";
  const isDark = variant === "dark";

  const wordColor = isDark ? "#F5F0EB" : "#0D1117";
  const accentColor = "#FF7100";
  const iconBg = accentColor;

  return (
    <div
      className={`flex items-center gap-2 ${isLg ? "gap-3" : "gap-2"}`}
      aria-label="NuȘtiiUndeÎi"
    >
      {/* Icon — orange rounded square with a stylised pin/location dot */}
      <span
        className={`flex items-center justify-center rounded-lg shrink-0 ${
          isLg ? "w-10 h-10" : "w-7 h-7"
        }`}
        style={{ background: iconBg }}
        aria-hidden="true"
      >
        <svg
          viewBox="0 0 20 20"
          fill="none"
          className={isLg ? "w-6 h-6" : "w-4 h-4"}
        >
          {/* Location pin */}
          <path
            d="M10 2a5.5 5.5 0 0 0-5.5 5.5c0 3.5 5.5 10.5 5.5 10.5S15.5 11 15.5 7.5A5.5 5.5 0 0 0 10 2z"
            fill="rgba(255,255,255,0.9)"
          />
          <circle cx="10" cy="7.5" r="2" fill={accentColor} />
        </svg>
      </span>

      {/* Wordmark */}
      <span
        className={`font-bold tracking-tight leading-none ${
          isLg ? "text-2xl" : "text-lg"
        }`}
      >
        <span style={{ color: wordColor }}>Nu</span>
        <span style={{ color: accentColor }}>Știi</span>
        <span style={{ color: wordColor }}>Unde</span>
        <span style={{ color: accentColor }}>Îi</span>
      </span>
    </div>
  );
}
